import React from 'react'
import { Send } from 'iconsax-react'
import { useAppSelector } from '@SonarCX/hooks/redux'

import CommonButton from '../CommonButton'

import { selectTaskStatus } from '@SonarCX/slices/taskStatus'
import { useAreYouSure } from '@SonarCX/providers/AreYouSureProvider'
import useTaskMultiEdit from '../hooks/useTaskMultiEdit'

const MarkComplete: React.FC = () => {
  const { statuses } = useAppSelector(selectTaskStatus)

  const { setV2, setTitle, setReason, setSubtext, setAction } = useAreYouSure()
  const { numTasks, suffix, plural, selected, patchTasks } = useTaskMultiEdit()

  const acceptAction = React.useCallback(() => {
    const completeStatus = statuses.find(
      status => status.base_status === 'completed'
    )

    if (!completeStatus) {
      return
    }

    const updates: TaskPatch[] = selected.map(id => ({
      id,
      status_id: completeStatus.id
    }))

    patchTasks({ updates })
  }, [statuses, selected, patchTasks])

  const handleClick = React.useCallback(() => {
    setV2(true)
    setTitle('Mark complete')
    setReason(`Are you sure you want to mark ${plural} task${suffix} complete?`)
    setSubtext(`Doing so will complete ${numTasks} task${suffix}.`)
    setAction(acceptAction)
  }, [
    plural,
    suffix,
    numTasks,
    setV2,
    setTitle,
    setReason,
    setSubtext,
    setAction,
    acceptAction
  ])

  return (
    <CommonButton title='Mark complete' Icon={Send} onClick={handleClick}>
      <div>Mark complete</div>
    </CommonButton>
  )
}

export default MarkComplete
